import styled from 'styled-components';

import media from '../../../../theme/media';

export const SearchBarContainer = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;

    ${media.tablet720} {
        width: calc(100% - 12px);
    }
`;
export const SearchBarContent = styled.div`
    background-color: ${(props) => props.theme.white};
    height: auto;
    pointer-events: auto;
    max-width: 528px;
    padding: 0 16px;
    margin: 0 auto;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;

    input[type='search'] {
        padding: 24px 16px;
        width: 100%;
        border: none;
        font-size: 17px;
        line-height: 24px;
        background: ${(props) => props.theme.white};
        color: ${(props) => props.theme.black};
        font-family: var(--font-main), sans-serif;
        outline: none;
        -webkit-appearance: none;

        ${media.tablet720} {
            padding: 32px 16px;
            font-size: 20px;
            line-height: 32px;
        }
    }
`;

export const Shadow = styled.div`
    box-shadow: ${(props) => props.theme.shadow_search};
    width: 100%;
    height: 16px;
    margin-top: -16px;
    margin-left: auto;
    margin-right: auto;

    ${media.tablet720} {
        max-width: 480px;
    }
`;
